import { render, staticRenderFns } from "./ApprovalFilePreview.vue?vue&type=template&id=1d6765e9&scoped=true"
import script from "./ApprovalFilePreview.vue?vue&type=script&lang=js"
export * from "./ApprovalFilePreview.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFilePreview.vue?vue&type=style&index=0&id=1d6765e9&scoped=true&lang=css"
import style1 from "./ApprovalFilePreview.vue?vue&type=style&index=1&id=1d6765e9&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6765e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6765e9')) {
      api.createRecord('1d6765e9', component.options)
    } else {
      api.reload('1d6765e9', component.options)
    }
    module.hot.accept("./ApprovalFilePreview.vue?vue&type=template&id=1d6765e9&scoped=true", function () {
      api.rerender('1d6765e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApprovalFilePreview.vue"
export default component.exports